








































































































































































































































































import DatePicker from '@/reusable/Form/DatePicker.vue';
import TimePicker from '@/reusable/Form/TimePicker.vue';
import moment from 'moment';
import Vue from 'vue';
import { fetchConfiguracionStreamax } from './../fetchConfiguracionStreamax';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import { EstadoEntidad } from '@/config/enums';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
@Component({
  components: {
    DatePicker,
    TimePicker,
    'app-confirmacion': Confirmation,
  },
})
export default class FormDualStreamStreamax extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  accion!: any;
  ordesList2: any;
  data: any = {};
  headers: any[] = [
    { text: 'Channel', align: 'start', sortable: false, key: 'canal' },
    { text: 'Enable', value: 'dato1', sortable: false },
    { text: 'Encode Standard', value: 'dato2', sortable: false },
    { text: 'Audio', value: 'dato3', sortable: false },
    { text: 'Resolution', value: 'dato4', sortable: false },
    { text: 'Frame Rate', value: 'dato5', sortable: false },
    { text: 'Quality', value: 'dato6', sortable: false },
    // ...
  ];
  tablaDatos: any[];
  selectedItems: string[] = [];
  checkboxes: any[] = [false, false, false, false, false];

  async getTimeSeleccionado() {
    let self = this;
    this.loadingService.showLoading();
    return fetchConfiguracionStreamax(
      { id_camara: this.selectedValue },
      'configCamaras/getConfCamaraRecordDualStreamax'
    )
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.loadingService.hideLoading();
          return data.data.data.LISTA;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          this.loadingService.hideLoading();
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
        this.loadingService.hideLoading();
      });
  }
  async getTime() {
    this.ordesList2 = (await this.getTimeSeleccionado()) || [];
    this.data = this.ordesList2[0];
    this.selectedItems = this.data['channels'];
    this.checkboxes = new Array(5).fill(false);
    this.selectedItems.forEach((item: string) => {
      const index = parseInt(item);
      this.checkboxes[index] = true;
    });
  }
  mounted(): void {
    this.getTime();
    this.onPropertyChanged();
    console.log(this.usuario);
  }
  onPropertyChanged() {
    this.tablaDatos = [
      {
        canal: '1',
        dato1: true,
        value2: 0,
        dato2: [{ label: 'H264', id: 0 }, { label: 'ON', id: 1 }],
        value3: 0,
        dato3: [{ label: 'Always Audio', id: 0 }, { label: 'ON', id: 1 }],
        value4: 0,
        dato4: [{ label: 'CIF', id: 0 }, { label: 'ON', id: 1 }],
        value5: 0,
        dato5: [{ label: '1', id: 0 }, { label: 'ON', id: 1 }],
        value6: 0,
        dato6: [{ label: '3', id: 0 }, { label: 'ON', id: 1 }],
      },
      {
        canal: '2',
        dato1: true,
        value2: 0,
        dato2: [{ label: 'H264', id: 0 }, { label: 'ON', id: 1 }],
        value3: 0,
        dato3: [{ label: 'Always Audio', id: 0 }, { label: 'ON', id: 1 }],
        value4: 0,
        dato4: [{ label: 'CIF', id: 0 }, { label: 'ON', id: 1 }],
        value5: 0,
        dato5: [{ label: '1', id: 0 }, { label: 'ON', id: 1 }],
        value6: 0,
        dato6: [{ label: '3', id: 0 }, { label: 'ON', id: 1 }],
      },
      {
        canal: '3',
        dato1: true,
        value2: 0,
        dato2: [{ label: 'H264', id: 0 }, { label: 'ON', id: 1 }],
        value3: 0,
        dato3: [{ label: 'Always Audio', id: 0 }, { label: 'ON', id: 1 }],
        value4: 0,
        dato4: [{ label: 'CIF', id: 0 }, { label: 'ON', id: 1 }],
        value5: 0,
        dato5: [{ label: '1', id: 0 }, { label: 'ON', id: 1 }],
        value6: 0,
        dato6: [{ label: '3', id: 0 }, { label: 'ON', id: 1 }],
      },
      {
        canal: '4',
        dato1: true,
        value2: 0,
        dato2: [{ label: 'H264', id: 0 }, { label: 'ON', id: 1 }],
        value3: 0,
        dato3: [{ label: 'Always Audio', id: 0 }, { label: 'ON', id: 1 }],
        value4: 0,
        dato4: [{ label: 'CIF', id: 0 }, { label: 'ON', id: 1 }],
        value5: 0,
        dato5: [{ label: '1', id: 0 }, { label: 'ON', id: 1 }],
        value6: 0,
        dato6: [{ label: '3', id: 0 }, { label: 'ON', id: 1 }],
      },
      {
        canal: '5',
        dato1: false,
        value2: 1,
        dato2: [{ label: 'H264', id: 0 }, { label: '', id: 1 }],
        value3: 1,
        dato3: [{ label: 'Always Audio', id: 0 }, { label: '', id: 1 }],
        value4: 1,
        dato4: [{ label: 'CIF', id: 0 }, { label: '', id: 1 }],
        value5: 1,
        dato5: [{ label: '1', id: 0 }, { label: '', id: 1 }],
        value6: 1,
        dato6: [{ label: '3', id: 0 }, { label: '', id: 1 }],
      },
    ];
  }
  formFields: {
    hddDoubleRecording: any;
    hddRecordDuration: any;
    sdWriteResourceRatio: any;
    recordStorage: any;
    recordMode: any;
    subStreamCH: any;
  } = {
    hddDoubleRecording: {
      label: 'HDD Double Recording',
      check: false,
    },
    hddRecordDuration: {
      label: 'HDD Record Duration',
      value: 50,
    },
    sdWriteResourceRatio: {
      label: 'SD Write Resource Ratio',
      value: '0.9 %',
    },
    recordStorage: {
      label: 'Record Storage',
      labelcheck1: 'Internal SD',
      labelcheck2: 'External SD',
      internalSd: true,
      externalSd: false,
    },
    recordMode: {
      label: 'Record Mode',
      value: '0',
      items: [
        { label: 'Sub-Record', id: '0' },
        { label: '2', id: '1' },
        { label: '3', id: '2' },
      ],
    },
    subStreamCH: {
      label: 'Sub-Stream CH',
      labelcheck1: '1',
      labelcheck2: '2',
      labelcheck3: '3',
      labelcheck4: '4',
      labelcheck5: '5',
    },
  };
  selectedRecordMode() {
    return this.formFields.recordMode.items.find(
      (item: { id: any }) => item.id === this.formFields.recordMode.value
    );
  }
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  datoEditado: any = {};

  grabarEdicion(val: boolean) {
    if (val) {
      const check: String[] = [];
      this.checkboxes.forEach((item, index) => {
        if (item) check.push(index.toString());
      });
      this.datoEditado.channels = check;
      if (!this.datoEditado.channels.length) {
        this.$snotify.error('Debe estar seleccionado minimo 1 canal ', {
          timeout: 3000,
        });
        this.confirmCallbackConfirm(false);
        return;
      }
      console.log(this.datoEditado.channels);
      this.editar();
    }
    this.confirmCallbackConfirm(false);
  }
  async editar() {
    let self = this;
    return fetchConfiguracionStreamax(
      {
        channels: JSON.stringify(this.datoEditado.channels),
        id_camara: this.selectedValue,
        usuario: this.usuario,
      },
      'configCamaras/saveConfChannels'
    )
      .then((data: any) => {
        //console.log(data.data);
        if (data.data.CODIGO_RESPUESTA == '1') {
          self.$snotify.success('Actualizacion exitosa', { timeout: 3000 });
          return null;
        } else {
          self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
      })
      .catch((error: any) => {
        self.$snotify.error('Ocurrió un error', { timeout: 3000 });
      });
    /* .finally(() => {
                return null;
              }); */
  }
  setBotonNav() {
    var accion = 'Editar';
    var evaluado = false;
    if (!this.esEdicion) {
      accion = 'Ver Detalle';
    }
  }
  cierraMenu() {
    var appBanners = document.getElementsByClassName(
      'ag-menu'
    ) as HTMLCollectionOf<HTMLElement>;
    if (appBanners.length > 0) {
      appBanners[0].remove();
    }
  }
  confirmCallback(val: any) {}
  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = val;
  }
}
